<div class="dialog-header">
  <h2>Contract Summary </h2>
  <!-- <a (click)="viewContract(contractForApproval.id)" matTooltip="View Contract" [matTooltipShowDelay]="300"
      [matTooltipHideDelay]="100"><ng-icon name="heroArrowTopRightOnSquare"></ng-icon></a> -->
  <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<mat-dialog-content class="approve">
  <div *ngIf="!formLoading; else loader">
    <table class="table">
      <tbody>
        <tr>
          <th>Contract Type</th>
          <td>{{ contractForApproval.contractTypeName }}</td>
        </tr>
        <tr>
          <th>Transaction Type</th>
          <td>{{ contractForApproval.transactionTypeName }}</td>
        </tr>
        <ng-container *ngIf="summaryAttributes.length > 0">
          <tr *ngFor="let attr of summaryAttributes">
            <th>{{ attr.attributeLabel }}</th>
            <td>{{ attr.attributeLabel.includes("Date") ? formatDate(attr.attributeValue) : attr.attributeValue }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <ng-template #loader>
    <div class="py-3 px-4">
      <ngx-skeleton-loader [theme]="{ height: '80px'}"></ngx-skeleton-loader>
      <div class="pt-3">
        <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
      </div>
      <div class="pt-3">
        <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
      </div>
      <div class="pt-3">
        <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
      </div>
      <div class="pt-3">
        <ngx-skeleton-loader [theme]="{ height: '50px', width: '20%', float: 'right'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ height: '50px', width: '20%', float: 'right'}"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end" *ngIf="!formLoading && [2,3].includes(data.activeTileIndication)">
  <button color="primary" mat-raised-button [disabled]="isLoading" class="outlined-btn" (click)="openRejectDialog()">{{
    data.activeTileIndication == 3 ? 'Reject' : 'Decline' }}
    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
  </button>
  <button color="accent" mat-raised-button class="ml-3" [disabled]="isLoading" (click)="approveOrReview()">{{
    data.activeTileIndication == 3 ? 'Approve' : 'Complete Review' }}
    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>